/**
 * Small pill for tags and lightweight labels.
 */
export function Badge({ children, className = '' }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0 text-[11px] font-semibold leading-5 ${className}`}
    >
      {children}
    </span>
  )
}
